/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RegistoAcessoCriteriaDto } from '../models/registo-acesso-criteria-dto';
import { RegistoAcessoDto } from '../models/registo-acesso-dto';
import { RegistoAcessoPageDto } from '../models/registo-acesso-page-dto';
import { RegistoModificacaoCriteriaDto } from '../models/registo-modificacao-criteria-dto';
import { RegistoModificacaoDto } from '../models/registo-modificacao-dto';
import { RegistoModificacaoPageDto } from '../models/registo-modificacao-page-dto';
import { TipoAcessoCriteriaDto } from '../models/tipo-acesso-criteria-dto';
import { TipoAcessoDto } from '../models/tipo-acesso-dto';
import { TipoAcessoFormDto } from '../models/tipo-acesso-form-dto';
import { TipoAcessoPageDto } from '../models/tipo-acesso-page-dto';
import { TipoRegistoCriteriaDto } from '../models/tipo-registo-criteria-dto';
import { TipoRegistoDto } from '../models/tipo-registo-dto';
import { TipoRegistoFormDto } from '../models/tipo-registo-form-dto';
import { TipoRegistoPageDto } from '../models/tipo-registo-page-dto';


/**
 * Registo de acessos e modificações
 */
@Injectable({
  providedIn: 'root',
})
export class AuditLogService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRegistosAcesso
   */
  static readonly GetRegistosAcessoPath = '/registos-acesso';

  /**
   * Pesquisar registos acessos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRegistosAcesso()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistosAcesso$Response(params?: {
    criteria?: RegistoAcessoCriteriaDto;
  }): Observable<StrictHttpResponse<RegistoAcessoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetRegistosAcessoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistoAcessoPageDto>;
      })
    );
  }

  /**
   * Pesquisar registos acessos.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRegistosAcesso$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistosAcesso(params?: {
    criteria?: RegistoAcessoCriteriaDto;
  }): Observable<RegistoAcessoPageDto> {

    return this.getRegistosAcesso$Response(params).pipe(
      map((r: StrictHttpResponse<RegistoAcessoPageDto>) => r.body as RegistoAcessoPageDto)
    );
  }

  /**
   * Path part for operation getRegistoAcesso
   */
  static readonly GetRegistoAcessoPath = '/registos-acesso/{id}';

  /**
   * Pesquisar registo acessos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRegistoAcesso()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistoAcesso$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<RegistoAcessoDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetRegistoAcessoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistoAcessoDto>;
      })
    );
  }

  /**
   * Pesquisar registo acessos.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRegistoAcesso$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistoAcesso(params: {
    id: number;
  }): Observable<RegistoAcessoDto> {

    return this.getRegistoAcesso$Response(params).pipe(
      map((r: StrictHttpResponse<RegistoAcessoDto>) => r.body as RegistoAcessoDto)
    );
  }

  /**
   * Path part for operation getRegistosModificacao
   */
  static readonly GetRegistosModificacaoPath = '/registos-modificacao';

  /**
   * Pesquisar registos modificação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRegistosModificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistosModificacao$Response(params?: {
    criteria?: RegistoModificacaoCriteriaDto;
  }): Observable<StrictHttpResponse<RegistoModificacaoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetRegistosModificacaoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistoModificacaoPageDto>;
      })
    );
  }

  /**
   * Pesquisar registos modificação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRegistosModificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistosModificacao(params?: {
    criteria?: RegistoModificacaoCriteriaDto;
  }): Observable<RegistoModificacaoPageDto> {

    return this.getRegistosModificacao$Response(params).pipe(
      map((r: StrictHttpResponse<RegistoModificacaoPageDto>) => r.body as RegistoModificacaoPageDto)
    );
  }

  /**
   * Path part for operation getRegistoModificacao
   */
  static readonly GetRegistoModificacaoPath = '/registos-modificacao/{id}';

  /**
   * Pesquisar registo modificacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRegistoModificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistoModificacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<RegistoModificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetRegistoModificacaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistoModificacaoDto>;
      })
    );
  }

  /**
   * Pesquisar registo modificacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRegistoModificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRegistoModificacao(params: {
    id: number;
  }): Observable<RegistoModificacaoDto> {

    return this.getRegistoModificacao$Response(params).pipe(
      map((r: StrictHttpResponse<RegistoModificacaoDto>) => r.body as RegistoModificacaoDto)
    );
  }

  /**
   * Path part for operation getTiposAcesso
   */
  static readonly GetTiposAcessoPath = '/tipos-acesso';

  /**
   * Pesquisar tipos de acesso.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposAcesso()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposAcesso$Response(params?: {
    criteria?: TipoAcessoCriteriaDto;
  }): Observable<StrictHttpResponse<TipoAcessoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetTiposAcessoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoAcessoPageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de acesso.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposAcesso$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposAcesso(params?: {
    criteria?: TipoAcessoCriteriaDto;
  }): Observable<TipoAcessoPageDto> {

    return this.getTiposAcesso$Response(params).pipe(
      map((r: StrictHttpResponse<TipoAcessoPageDto>) => r.body as TipoAcessoPageDto)
    );
  }

  /**
   * Path part for operation getTipoAcesso
   */
  static readonly GetTipoAcessoPath = '/tipos-acesso/{id}';

  /**
   * Obter tipo de acesso.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoAcesso()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoAcesso$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoAcessoDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetTipoAcessoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoAcessoDto>;
      })
    );
  }

  /**
   * Obter tipo de acesso.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoAcesso$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoAcesso(params: {
    id: number;
  }): Observable<TipoAcessoDto> {

    return this.getTipoAcesso$Response(params).pipe(
      map((r: StrictHttpResponse<TipoAcessoDto>) => r.body as TipoAcessoDto)
    );
  }

  /**
   * Path part for operation updateTipoAcesso
   */
  static readonly UpdateTipoAcessoPath = '/tipos-acesso/{id}';

  /**
   * Alterar tipo de acesso.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoAcesso()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoAcesso$Response(params: {
    id: number;
    body?: TipoAcessoFormDto
  }): Observable<StrictHttpResponse<TipoAcessoDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.UpdateTipoAcessoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoAcessoDto>;
      })
    );
  }

  /**
   * Alterar tipo de acesso.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoAcesso$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoAcesso(params: {
    id: number;
    body?: TipoAcessoFormDto
  }): Observable<TipoAcessoDto> {

    return this.updateTipoAcesso$Response(params).pipe(
      map((r: StrictHttpResponse<TipoAcessoDto>) => r.body as TipoAcessoDto)
    );
  }

  /**
   * Path part for operation getTiposRegisto
   */
  static readonly GetTiposRegistoPath = '/tipos-registo';

  /**
   * Pesquisar tipos de registo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposRegisto()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposRegisto$Response(params?: {
    criteria?: TipoRegistoCriteriaDto;
  }): Observable<StrictHttpResponse<TipoRegistoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetTiposRegistoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoRegistoPageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de registo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposRegisto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposRegisto(params?: {
    criteria?: TipoRegistoCriteriaDto;
  }): Observable<TipoRegistoPageDto> {

    return this.getTiposRegisto$Response(params).pipe(
      map((r: StrictHttpResponse<TipoRegistoPageDto>) => r.body as TipoRegistoPageDto)
    );
  }

  /**
   * Path part for operation getTipoRegisto
   */
  static readonly GetTipoRegistoPath = '/tipos-registo/{id}';

  /**
   * Obter tipo de registo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoRegisto()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoRegisto$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoRegistoDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.GetTipoRegistoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoRegistoDto>;
      })
    );
  }

  /**
   * Obter tipo de registo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoRegisto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoRegisto(params: {
    id: number;
  }): Observable<TipoRegistoDto> {

    return this.getTipoRegisto$Response(params).pipe(
      map((r: StrictHttpResponse<TipoRegistoDto>) => r.body as TipoRegistoDto)
    );
  }

  /**
   * Path part for operation updateTipoRegisto
   */
  static readonly UpdateTipoRegistoPath = '/tipos-registo/{id}';

  /**
   * Alterar tipo de registo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoRegisto()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoRegisto$Response(params: {
    id: number;
    body?: TipoRegistoFormDto
  }): Observable<StrictHttpResponse<TipoRegistoDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditLogService.UpdateTipoRegistoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoRegistoDto>;
      })
    );
  }

  /**
   * Alterar tipo de registo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoRegisto$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoRegisto(params: {
    id: number;
    body?: TipoRegistoFormDto
  }): Observable<TipoRegistoDto> {

    return this.updateTipoRegisto$Response(params).pipe(
      map((r: StrictHttpResponse<TipoRegistoDto>) => r.body as TipoRegistoDto)
    );
  }

}
